// Thumbnail slider
const thumbsSwiper = new Swiper(".thumbs-swiper", {
    slidesPerView: 5,
    spaceBetween: 21,
    watchSlidesProgress: true,
    pagination: {
        el: ".thumbs-swiper .swiper-pagination",
        clickable: true,
    },
});

// Main slider (NO pagination)
const mainSwiper = new Swiper(".product-swiper", {
    loop: true,
    thumbs: {
        swiper: thumbsSwiper,
    },
});


// Thumb Arrow
const prevThumbButton = document.querySelector(".thumb-arrow.thumb-prev");
const nextThumbButton = document.querySelector(".thumb-next");


prevThumbButton.addEventListener('click', () => {
    mainSwiper.slidePrev();
})

nextThumbButton.addEventListener('click', () => {
    mainSwiper.slideNext();
})

// Total No of Slides
const indicatorWrapper = document.querySelector(
    ".thumb-slide-indicator__wrapper"
);
const totalSlides = mainSwiper.slides.length;
indicatorWrapper.innerHTML = ""; // reset if needed


for (let i = 0; i < totalSlides; i++) {
    const dot = document.createElement("button");
    dot.classList.add("thumb-slider-indicator__dot");
    dot.dataset.index = i;

    dot.addEventListener("click", () => {
        mainSwiper.slideToLoop(i); // ✅ loop-safe
    });

    indicatorWrapper.appendChild(dot);
}


// Add .dot-active class to active slider
const dots = indicatorWrapper.querySelectorAll(
    ".thumb-slider-indicator__dot"
);

// 🔁 Sync active dot with slider
function updateActiveDot() {
    dots.forEach(dot => dot.classList.remove("dot-active"));

    dots.forEach((dot, index) => {
        if (index === mainSwiper.realIndex) {
            dot.classList.add("dot-active");
        }
    });
}

mainSwiper.on("slideChange", updateActiveDot);

// Initial state
updateActiveDot();

// Slide Indicator Logic


// ===============
// =====options=====
// ===============
// OPTION
(function () {
    const form = document.getElementById("flavorForm");
    const flavor = document.getElementById("flavor");
    const trigger = flavor.querySelector(".flavor__trigger");
    const valueText = flavor.querySelector(".flavor__value");
    const valueImg = flavor.querySelector(".flavor__img");
    const options = flavor.querySelectorAll(".flavor__option");

    // Toggle dropdown (FIXED)
    trigger.addEventListener("click", () => {
        const open = flavor.classList.toggle("is-open");
        trigger.setAttribute("aria-expanded", open);
    });

    // Select option
    options.forEach(option => {
        option.addEventListener("click", () => {
            valueText.textContent = option.dataset.label;
            valueImg.src = option.dataset.img;
            

            flavor.classList.remove("is-open");
            trigger.setAttribute("aria-expanded", "false");

            // Add URL redirect
            
            const url = option.dataset.url;
            if (url) {
                window.location.href = url;
            }
        });
    });

    // Outside click close
    document.addEventListener("click", e => {
        if (!flavor.contains(e.target)) {
            flavor.classList.remove("is-open");
            trigger.setAttribute("aria-expanded", "false");
        }
    });

    // Submit
    form.addEventListener("submit", e => {
        e.preventDefault();
        console.log("Form submitted:", hiddenInput.value);
    });

    // Option redirect

})();




// document.addEventListener("DOMContentLoaded", () => {
//   const flavor = document.getElementById("flavor");
//   if (!flavor) return;

//   const trigger = flavor.querySelector(".flavor__trigger");
//   const valueEl = flavor.querySelector(".flavor__value");
//   const imgEl = flavor.querySelector(".flavor__img");
//   const options = flavor.querySelectorAll(".flavor__option");

//   options.forEach(option => {
//     option.addEventListener("click", () => {
//       alert("Clicked");

//       const { label, img, url } = option.dataset;

//       valueEl.textContent = label;
//       imgEl.src = img;
// if (url) {
//         window.location.href = url;
//       }
      
//     });
//   });
// });






